import React, { useEffect } from 'react'
import { Header } from './header'
import { Footer } from './footer'
import { LoginModal } from '~/components/business/LoginModal'
import { RealNameModal } from '~/components/pages/settings/RealNameModal'
import { useStores } from '~/hooks/useStores'
import { observer } from 'mobx-react'
import { SetTradePwdModal } from '~/components/business/SetTradePwdModal'
import { RightBar } from '~/components/business/RightBar'
import { GetProductModal } from '~/components/business/GetProductModal'
import { AnalyticsScript } from '~/components/business/AnalyticsScript'
import { useAuth } from '~/hooks/useAuth'
import { ThemeType } from '~/graphqls/types'
import classNames from 'classnames'
import { useGray } from '~/hooks/useGray'

export const Layout: React.FC<{ className?: string }> = observer(
  ({ children, className }) => {
    const { store } = useStores()
    const { isLogin } = useAuth()
    const { isGray } = useGray()

    const loginVisible = !!store.modal?.login
    const setTradePwdVisible = !!store.modal?.setTradePwd
    const realNameAuthVisible = !!store.modal?.realNameAuth
    const setRealNameAuthVisible = store.modal?.setRealNameAuthVisible
    const isDarkMode = store.themeMode === ThemeType.DARK

    const isProd = process.env.NEXT_PUBLIC_NODE_ENV === 'production'

    useEffect(() => {
      document.documentElement.style.background = isDarkMode
        ? '#141416'
        : '#ffffff'
    }, [isDarkMode])

    useEffect(() => {
      window.oncontextmenu = function (e) {
        // 大佬需求，不让右键下载图片
        if ((e?.target as any)?.nodeName === 'IMG') {
          e.preventDefault()
        }
      }
    }, [])

    return (
      <div
        className={classNames(
          'min-h-screen',
          isDarkMode ? 'bg-neutral-100' : 'bg-neutral-800',
          isGray && 'global-gray-bg',
          className
        )}
      >
        <Header />
        {children}
        <Footer />
        {!isDarkMode && <RightBar />}
        {loginVisible && <LoginModal />}
        {realNameAuthVisible && (
          <RealNameModal
            visible={realNameAuthVisible}
            setVisible={setRealNameAuthVisible!}
          />
        )}
        {setTradePwdVisible && <SetTradePwdModal />}
        {isLogin && <GetProductModal />}
        {isProd && <AnalyticsScript />}
      </div>
    )
  }
)
